<template>
  <v-snackbar
    :class="`fixit-snackbar fixit-snackbar__${snackbar.state}`"
    :duration="snackbar.duration"
    :value="snackbar.visible"
    centered
  >
    <div class="fixit-snackbar__body">
      <v-icon
        :class="`fixit-snackbar__body--icon-${snackbar.state}`"
        v-if="snackbar.state == 'error'"
        color="error"
        >fxt-warning</v-icon
      >
      <v-icon
        :class="`fixit-snackbar__body--icon-${snackbar.state}`"
        v-if="snackbar.state == 'info'"
        color="primary"
        >fxt-check</v-icon
      >
      <span :class="`fixit-snackbar__body--message-${snackbar.state}`">{{
        snackbar.message
      }}</span>
    </div>
  </v-snackbar>
</template>
<script>
import {Notification} from "./models";
export default {
  name: "fixitno-snackbar",
  props: {
    snackbar: {
      type: [Notification, Object],
      required: true,
    },
  },
  methods: {
    closeSnackbar() {
      this.$emit("removeSnackbar", null);
    },
  },
  watch: {
    snackbar(a) {
      if (a.visible == true) {
        setTimeout(this.closeSnackbar, a.duration);
      }
    },
  },
  created(){
  }
};
</script>
<style lang="scss">
.fixit-snackbar {
  z-index: 555 !important; 
  height: 100vh !important;
  .v-snack__wrapper {
    position: absolute !important;
    bottom: 50px !important;
  }
  &__error {
    .v-snack__wrapper {
      background-image: linear-gradient(var(--v-primary-opacity-12) 100%, var(--v-primary-opacity-12) 100%);
      background-color: white !important;
    }
  }
  &__info {
    .v-snack__wrapper {
      background-image: linear-gradient(var(--v-primary-opacity-12) 100%, var(--v-primary-opacity-12) 100%);
      background-color: white !important;
    }
  }
  &__body {
    &--message {
      &-error {
        color: #222222 !important;
      }
      &-info {
        color: #222222 !important;
      }
    }
  }
}
</style>